import { Box, Typography } from '@mui/material';

export default function SelectAField() {
  return (
    <Box
      sx={{
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        textAlign: 'center',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: 'white',
      }}
    >
      <Typography variant="h2">Select A Field</Typography>
      <Typography variant="h5" sx={{ mt: 2 }}>
        Select the field you want to continue.
      </Typography>
    </Box>
  );
}
